﻿function initUniversalsTabber() {
    const tabbers = document.querySelectorAll('.country-tabber a');
    const countryCards = document.querySelectorAll('.country-cards-item');

    const removeActiveTabber = () => {
        tabbers.forEach(tabber => {
            tabber.classList.remove('tabber--active');
        })
    }
    const addActiveTabber = tabber => {
        tabber.classList.add('tabber--active');
        countryCards.forEach(countryCard => {
            if (countryCard.getAttribute('data-region') === tabber.getAttribute('data-region')) {
                countryCard.classList.remove('hide-country-card');

            }
            else {

                countryCard.classList.add('hide-country-card');
            }
        })
    }

    tabbers.forEach(tabber => {
        tabber.addEventListener('click', e => {
            e.preventDefault();
            //console.log(tabber.getAttribute('data-region'));
            removeActiveTabber();
            addActiveTabber(tabber);
        })
    });
}

initUniversalsTabber();